import { apiRequest } from './client'
import { demoProductTypes } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'
import { readInt, readString } from './json'

export type ProductTypeDto = {
  id: number
  parentId: number | null
  code: string
  name: string
  active: boolean
}

type ProductTypeRaw = Record<string, unknown>

const normalizeProductType = (raw: ProductTypeRaw): ProductTypeDto => ({
  id: readInt(raw, 'id', 'id'),
  parentId: raw.parentId != null ? Number(raw.parentId) : raw.parent_id != null ? Number(raw.parent_id) : null,
  code: readString(raw, 'code', 'code') ?? '',
  name: readString(raw, 'name', 'name') ?? '',
  active: raw.active !== false,
})

export const listProductTypes = async (): Promise<ProductTypeDto[]> =>
  withDemoUi(demoProductTypes, async () => {
  const items = await apiRequest<ProductTypeRaw[]>('/product-types')
  return items.map(normalizeProductType)
})

export const resolveProductTypes = async (ids: number[]): Promise<ProductTypeDto[]> => {
  const unique = [...new Set(ids.filter((id) => Number.isFinite(id) && id > 0))]
  if (unique.length === 0) {
    return []
  }
  return withDemoUi(
    demoProductTypes.filter((type) => unique.includes(type.id)),
    async () => {
  const query = unique.map((id) => `ids=${id}`).join('&')
  const items = await apiRequest<ProductTypeRaw[]>(`/product-types/resolve?${query}`)
  return items.map(normalizeProductType)
})
}

export const mergeProductTypes = (
  active: ProductTypeDto[],
  extra: ProductTypeDto[],
): ProductTypeDto[] => {
  const byId = new Map(active.map((type) => [type.id, type]))
  for (const type of extra) {
    if (!type.active) {
      continue
    }
    if (!byId.has(type.id)) {
      byId.set(type.id, type)
    }
  }
  return [...byId.values()]
}
